import { StateAppInfo } from '@/state/app_info/state_app_info';
import { STATE__collections } from '@/state/collection/STATE__collections';
import { StateMLAsset } from '@/state/diffusion_models_ud/state_ml_asset';
import { STATE__generation } from '@/state/generation/STATE__generation';
import { StateGenerationPrice } from '@/state/generation_price/state_generation_price';
import { STATE__grid2d } from '@/state/grid2d/STATE__grid2d';
import { STATE__images } from '@/state/images/STATE__images';
import { STATE__network } from '@/state/network/STATE__network';
import { StateSearch } from '@/state/search/state_search';
import { STATE__ui } from '@/state/ui/STATE__ui';
import { StateUser } from '@/state/user/state_user';
import { StateWords } from '@/state/words/state_words';
import { StateWorkspaceBilling } from '@/state/workspace/billing/state_workspace_billing';
import { STATE__workspace } from '@/state/workspace/STATE__workspace';
import { use_slice_pick_base } from './use_slice_pick_base';

export const use_slice_app_info = <T extends keyof StateAppInfo>(keys: T[]) => use_slice_pick_base('slice_app_info', keys);

export const use_slice_collections = <T extends keyof STATE__collections>(keys: T[]) => use_slice_pick_base('slice_collections', keys);

export const use_slice_ml_asset = <T extends keyof StateMLAsset>(keys: T[]) => use_slice_pick_base('slice_ml_asset', keys);

export const use_slice_generation = <T extends keyof STATE__generation>(keys: T[]) => use_slice_pick_base('slice_generation', keys);

export const use_slice_generation_price = <T extends keyof StateGenerationPrice>(keys: T[]) => use_slice_pick_base('slice_generation_price', keys);

export const use_slice_grid2d = <T extends keyof STATE__grid2d>(keys: T[]) => use_slice_pick_base('slice_grid2d', keys);

export const use_slice_images = <T extends keyof STATE__images>(keys: T[]) => use_slice_pick_base('slice_images', keys);

export const use_slice_network = <T extends keyof STATE__network>(keys: T[]) => use_slice_pick_base('slice_network', keys);

export const use_slice_search = <T extends keyof StateSearch>(keys: T[]) => use_slice_pick_base('slice_search', keys);

export const use_slice_ui = <T extends keyof STATE__ui>(keys: T[]) => use_slice_pick_base('slice_ui', keys);

export const use_slice_user = <T extends keyof StateUser>(keys: T[]) => use_slice_pick_base('slice_user', keys);

export const use_slice_workspace = <T extends keyof STATE__workspace>(keys: T[]) => use_slice_pick_base('slice_workspace', keys);

export const use_slice_workspace_billing = <T extends keyof StateWorkspaceBilling>(keys: T[]) => use_slice_pick_base('slice_workspace_billing', keys);

export const use_slice_words = <T extends keyof StateWords>(keys: T[]) => use_slice_pick_base('slice_words', keys);
